import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loginStart, loginSuccess, loginFailure } from '../../store/slices/authSlice';
import apiClient from '../../services/api';
import './AdminLogin.css';

function AdminLogin() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    dispatch(loginStart());

    try {
      // Use regular login endpoint - it will check role on backend
      const response = await apiClient.post('/api/v1/auth/login', 
        new URLSearchParams({ username: email, password }),
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
      );

      const { access_token, refresh_token } = response.data;

      // Get user info to check role
      const userResponse = await apiClient.get('/api/v1/auth/me', {
        headers: { Authorization: `Bearer ${access_token}` }
      });

      const user = userResponse.data;

      // Check if user is admin
      if (!['admin', 'superadmin'].includes(user.role)) {
        setError('Access denied. Admin privileges required.');
        dispatch(loginFailure('Access denied'));
        return;
      }

      dispatch(loginSuccess({
        user,
        token: access_token,
        refreshToken: refresh_token
      }));

      navigate('/admin/dashboard');
    } catch (err) {
      const errorMessage = err.response?.data?.detail || 'Login failed';
      setError(errorMessage);
      dispatch(loginFailure(errorMessage));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-card">
        <div className="admin-login-header">
          <h1>Admin Login</h1>
          <p>Sign in to access the admin dashboard</p>
        </div>
        <form onSubmit={handleSubmit} className="admin-login-form" aria-label="Admin login form">
          {error && (
            <div className="error-message" role="alert" aria-live="polite">
              {error}
            </div>
          )}
          <div className="form-group">
            <label htmlFor="admin-email">Email</label>
            <input
              id="admin-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              aria-required="true"
              aria-label="Email address"
              autoComplete="email"
            />
          </div>
          <div className="form-group">
            <label htmlFor="admin-password">Password</label>
            <input
              id="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
              aria-required="true"
              aria-label="Password"
              autoComplete="current-password"
              onKeyDown={(e) => {
                if (e.key === 'Enter' && email && password && !loading) {
                  handleSubmit(e);
                }
              }}
            />
          </div>
          <button 
            type="submit" 
            className="login-button" 
            disabled={loading}
            aria-label="Submit admin login"
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                if (!loading) {
                  handleSubmit(e);
                }
              }
            }}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminLogin;

